import service from '@/store/services/settings/level-service';

const state = {
    list: {},
    level: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, level) => {
        state.level = level;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(level => {
                commit('SET_RESOURCE', level);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(level => {
                commit('SET_RESOURCE', level);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((level) => {
                commit('SET_RESOURCE', level);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((level) => {
                commit('SET_RESOURCE', level);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    level: state => state.level,
    dropdown: (state) => {
        return state.list.map(level => ({
            id: level.id,
        }));
    }
};

const levels = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default levels;

